import React from "react";
import { FILTER_SEPARATOR, PERMISSIONS, SERVICE_TYPE_OPTIONS } from "@/constants";
import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import { EyeIcon } from "@phosphor-icons/react/dist/ssr/Eye";
import { useFormContext } from "react-hook-form";

import { ComponentLoader } from "../componentLoader/component-loader";
import { useAuth } from "../core/auth-provider";
import { DynamicField } from "./dynamic-field";
import { DynamicFieldType } from "./types";
import { useServicesList } from "@/hooks/api/use-services";
import { appHref } from "@/lib/platform";

export function ServicePluginField({
	field,
	dynamicField,
	service,
}: {
	field: any;
	dynamicField: any;
	onChange?: (value: string) => void;
	label?: string;
	service: string;
}) {
	const { data: servicesPlugins, isLoading: isServicesPluginsLoading } = useServicesList(`offset=0&limit=100&type=${service}`);

	const { control, setValue } = useFormContext();
	const { permissions } = useAuth();

	const serviceLabel = SERVICE_TYPE_OPTIONS.find((option) => option.value === service)?.label;
	const hasServicesPermissions = permissions[PERMISSIONS.service];

	const handleViewPlugins = () => {
		window.open(appHref(`/plugins/services?type=${serviceLabel}${FILTER_SEPARATOR}${service}`), "_blank");
	};

	return (
		<>
			<ComponentLoader loading={isServicesPluginsLoading} />
			<Grid container spacing={2}>
				<Grid size={{ md: 12, xs: 12 }}>
					<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2 }}>
						<DynamicField
							control={control}
							type={DynamicFieldType.SELECT}
							name={field.name}
							label={dynamicField.label}
							onChange={(value) => setValue(field.name, value)}
              dependsOn={dynamicField.dependsOn}
              formName={dynamicField.formName}
							dynamicField={{
                ...dynamicField,
								options: servicesPlugins?.data?.map((plugin: any) => ({ value: plugin.id, label: plugin.title })),
							}}
						/>

						{hasServicesPermissions && !isServicesPluginsLoading && (
							<Box sx={{ display: "flex", gap: 1, mt: 3.5 }}>
								<Tooltip title={`View ${serviceLabel} Services`} arrow>
									<IconButton color="primary" onClick={handleViewPlugins}>
										<EyeIcon weight="fill" />
									</IconButton>
								</Tooltip>
							</Box>
						)}
					</Box>
				</Grid>
			</Grid>
		</>
	);
}
